// state.js — shared state for V4 modules
// app-legacy.js exposes its own state as window.__wmmLegacyState on load.
// V4 modules read from this shared object and add their own fields.

export const state = {
  // V4-only state fields
  intakeSource: 'all',
  currentView: 'dashboard',
  davidSessionId: null,
  currentShowId: null,   // writable — updated by switchShow in client-card.js
  currentTab: null,      // writable — updated by wireTabClicks in client-card.js

  // Proxy getters for data maintained by app-legacy.js
  get clients() {
    return window.__wmmLegacyState?.clients || [];
  },
  get currentClientId() {
    return window.__wmmLegacyState?.currentClientId || null;
  },
};
